import { render, staticRenderFns } from "./EquippedItems.vue?vue&type=template&id=3c1ad595"
import script from "./EquippedItems.vue?vue&type=script&lang=js"
export * from "./EquippedItems.vue?vue&type=script&lang=js"
import style0 from "./EquippedItems.vue?vue&type=style&index=0&id=3c1ad595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports